function getOrFixMonth(val) {
  let month = val.substring(0, 2);
  if (month.length === 1) {
    if (month === '/') {
      month = '';
    }
  } else if (month.length === 2) {
    if (month.endsWith('/')) {
      month = `0${month}`;
    } else if (month.startsWith('/')) {
      month = '';
    }
  } else {
    month = '';
  }
  return month;
}

function handleChangeFirstChars(val) {
  // this is an edge case when you have, for example, "01/" and the users goes back with
  // the cursor on the first position and type "2" the result should be "20/1".
  // we can only achieve this result with this function
  let value = val;
  if ((value.length === 4 || value.length === 5) && value.endsWith('/')) {
    const n = Number(value.substring(0, 3));
    if (Number.isInteger(n)) {
      value = value.replace('/', '');
      value = `${value.substring(0, 2)}/${value.substring(2, 4)}`;
      return value;
    }
  }
  return value;
}

function handleCopyAndPaste(val) {
  const split = val.split('/');
  if (split.length === 3) {
    const first = split[0].length === 1 ? `0${split[0]}` : split[0];
    const second = split[1].length === 1 ? `0${split[1]}` : split[1];
    const third = split[2];
    return `${first.substring(0, 2)}/${second.substring(0, 2)}/${third.substring(0, 4)}`;
  }
  return val;
}

// this is our custom implementation for date masks in this format mm/dd/yyyy
// it allows users to type, for example, "1/1/2000" which will be converted to "10/10/2000"
export function formatDates(val) {
  const value = handleCopyAndPaste(handleChangeFirstChars(val));

  let month = getOrFixMonth(value);

  if (value === '/') {
    return '';
  }
  if (value === month) {
    return month;
  }
  month = month.replace('/', '');

  let day = value.substring(2, 5);
  if (day.length === 1) {
    if (day === '/') {
      return `${month}/`;
    }
    return `${month}/${day}`;
  }

  day = day.replace('/', '');
  if (day.length === 2) {
    if (day.endsWith('/')) {
      day = `0${day}`;
    }
  }
  day = day.replace('/', '');
  if (day === value.substring(3)) {
    return `${month}/${day}`;
  }

  if (day.length > 2) {
    return `${month}/${day.substring(0, 2)}/${day.substring(2)}${value.substring(5, 8)}`;
  }

  let year = value.substring(5, 10);
  if (year === '/') {
    return `${month}/${day}/`;
  }

  year = year.replace(/\//g, '');
  if (year) {
    return `${month}/${day}/${year}`;
  }
  return `${month}/${day}`;
}

// same as formatDate, but with this format mm/yyyy
export function formatShortDates(val) {
  if (val === '/') {
    return '';
  }
  const value = handleChangeFirstChars(val);

  const split = value.split('/');
  if (split.length === 2) {
    const first = split[0].length === 1 ? `0${split[0]}` : split[0];
    const second = split[1];
    return `${first.substring(0, 2)}/${second.substring(0, 4)}`;
  }

  let month = getOrFixMonth(value);

  if (value === month) {
    return month;
  }
  month = month.replace('/', '');

  let year = value.substring(2, 7);
  year = year.replace(/\//g, '');
  return `${month}/${year.substring(0, 4)}`;
}

export function removeFormatting(val) {
  // the internal masking library (react-number-format) only support numbers.
  // this function overrides that behavior allowing also: "/", "-" and ".".
  return val.replace(/[^0-9/]+/g, '');
}
